/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ShareClaimRequestOneOf } from './ShareClaimRequestOneOf';
import {
    instanceOfShareClaimRequestOneOf,
    ShareClaimRequestOneOfFromJSON,
    ShareClaimRequestOneOfFromJSONTyped,
    ShareClaimRequestOneOfToJSON,
} from './ShareClaimRequestOneOf';
import type { ShareClaimRequestOneOf1 } from './ShareClaimRequestOneOf1';
import {
    instanceOfShareClaimRequestOneOf1,
    ShareClaimRequestOneOf1FromJSON,
    ShareClaimRequestOneOf1FromJSONTyped,
    ShareClaimRequestOneOf1ToJSON,
} from './ShareClaimRequestOneOf1';
import type { ShareClaimRequestOneOf2 } from './ShareClaimRequestOneOf2';
import {
    instanceOfShareClaimRequestOneOf2,
    ShareClaimRequestOneOf2FromJSON,
    ShareClaimRequestOneOf2FromJSONTyped,
    ShareClaimRequestOneOf2ToJSON,
} from './ShareClaimRequestOneOf2';
import type { ShareClaimRequestOneOf3 } from './ShareClaimRequestOneOf3';
import {
    instanceOfShareClaimRequestOneOf3,
    ShareClaimRequestOneOf3FromJSON,
    ShareClaimRequestOneOf3FromJSONTyped,
    ShareClaimRequestOneOf3ToJSON,
} from './ShareClaimRequestOneOf3';

/**
 * @type ShareClaimRequest
 * 
 * @export
 */
export type ShareClaimRequest = ShareClaimRequestOneOf | ShareClaimRequestOneOf1 | ShareClaimRequestOneOf2 | ShareClaimRequestOneOf3;

export function ShareClaimRequestFromJSON(json: any): ShareClaimRequest {
    return ShareClaimRequestFromJSONTyped(json, false);
}

export function ShareClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimRequest {
    if (json == null) {
        return json;
    }
    if (instanceOfShareClaimRequestOneOf(json)) {
        return ShareClaimRequestOneOfFromJSONTyped(json, true);
    }
    if (instanceOfShareClaimRequestOneOf1(json)) {
        return ShareClaimRequestOneOf1FromJSONTyped(json, true);
    }
    if (instanceOfShareClaimRequestOneOf2(json)) {
        return ShareClaimRequestOneOf2FromJSONTyped(json, true);
    }
    if (instanceOfShareClaimRequestOneOf3(json)) {
        return ShareClaimRequestOneOf3FromJSONTyped(json, true);
    }

    return {} as any;
}

export function ShareClaimRequestToJSON(json: any): any {
    return ShareClaimRequestToJSONTyped(json, false);
}

export function ShareClaimRequestToJSONTyped(value?: ShareClaimRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfShareClaimRequestOneOf(value)) {
        return ShareClaimRequestOneOfToJSON(value as ShareClaimRequestOneOf);
    }
    if (instanceOfShareClaimRequestOneOf1(value)) {
        return ShareClaimRequestOneOf1ToJSON(value as ShareClaimRequestOneOf1);
    }
    if (instanceOfShareClaimRequestOneOf2(value)) {
        return ShareClaimRequestOneOf2ToJSON(value as ShareClaimRequestOneOf2);
    }
    if (instanceOfShareClaimRequestOneOf3(value)) {
        return ShareClaimRequestOneOf3ToJSON(value as ShareClaimRequestOneOf3);
    }

    return {};
}

